import { render, staticRenderFns } from "./FoShanMap.vue?vue&type=template&id=38ac8d63&"
import script from "./FoShanMap.vue?vue&type=script&lang=js&"
export * from "./FoShanMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports